// @ts-check
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Triggers API to pull master list of Divisions, Groups and Depts for use across app modules
 * Data is stored in divisionMasterList reducer & redux-persist. If no data/no toggle, UI falls back to hardcoded lists
 * Master list will be cleared from redux state if toggle is off & persisted data is still present
 * Should be placed after ConfigurationLoader in app hierarchy and rendered only once.
 *
 * @returns {null}
 */

export const DivisionListLoader = ({ getMasterDivisionsList }) => {
  React.useEffect(() => {
    getMasterDivisionsList();
  }, []);

  return null;
};

DivisionListLoader.propTypes = {
  getMasterDivisionsList: PropTypes.func,
  isMasterDivisionListenabled: PropTypes.bool,
};

DivisionListLoader.defaultProps = {
  getMasterDivisionsList: () => {},
  isMasterDivisionListenabled: false,
};

export default DivisionListLoader;
